var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "max-width": "1200",
      "min-height": "200",
      "width": "100%"
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex flex-column flex-sm-row"
  }, [_c('v-img', {
    staticClass: "mx-auto mx-sm-0",
    attrs: {
      "src": _vm.item.thumbnail,
      "height": "100%",
      "max-width": "120",
      "width": "120",
      "cover": ""
    }
  }), _c('v-sheet', {
    staticClass: "d-flex flex-column justify-start pl-4",
    attrs: {
      "color": "transparent"
    }
  }, [_c('h5', {
    staticClass: "text-h6 font-weight-bold"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.titleCatalogUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.item.title))])]), _c('h6', {
    staticClass: "text-subtitle-1 primary--text"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.authorCatalogUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.item.author))])]), _c('h6', {
    staticClass: "text-subtitle-2"
  }, [_vm._v(_vm._s(_vm.item.publishing || ''))]), _c('v-sheet', {
    staticClass: "description-sheet mt-2",
    attrs: {
      "color": "transparent"
    }
  }, [_c('p', {
    staticClass: "text-body-1",
    domProps: {
      "innerHTML": _vm._s(_vm.isExpanded ? _vm.item.description : _vm.item.descriptionShort || '')
    }
  }), _vm.item.isExpandable ? _c('v-btn', {
    staticClass: "expand-btn",
    attrs: {
      "color": "primary",
      "icon": "",
      "large": ""
    },
    on: {
      "click": function ($event) {
        _vm.isExpanded = !_vm.isExpanded;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v(_vm._s(("mdi-menu-" + (_vm.isExpanded ? 'up' : 'down'))))])], 1) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }